export const TOKEN_KEY = '&app_token';

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = token => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => {
  
  //removendo as variáveis de sessão registradas 
  sessionStorage.removeItem('limit');
  sessionStorage.removeItem('area');
  sessionStorage.removeItem('bairro');
  sessionStorage.removeItem('status');
  sessionStorage.removeItem('occurrenceStatus');
  sessionStorage.removeItem('group');

  localStorage.removeItem(TOKEN_KEY);
  window.location.href = '/';
};